import React from 'react'
import AnimatedText2 from './AnimatedText2'
import Marquee from 'react-fast-marquee'
import iconorange from '../images/icon_orange.svg';
// journey banner
import journey1 from '../images/portfolio/1.webp';
import journey2 from '../images/portfolio/2.webp';
import journey3 from '../images/portfolio/3.webp';
import journey4 from '../images/portfolio/4.webp';
import journey5 from '../images/portfolio/5.webp';
import journey6 from '../images/portfolio/6.webp';
import journey7 from '../images/portfolio/7.webp';
import journey8 from '../images/portfolio/8.webp';
import journey9 from '../images/portfolio/9.webp';
import journey10 from '../images/portfolio/10.webp';
import journey11 from '../images/portfolio/11.webp';
import jlogo1 from '../images/portfolio/1 logo.webp';
import jlogo2 from '../images/portfolio/2 logo.png';
import jlogo3 from '../images/portfolio/3 logo.webp';
import jlogo4 from '../images/portfolio/4 logo.webp';
import jlogo5 from '../images/portfolio/5 logo.webp';
import jlogo6 from '../images/portfolio/6 logo.png';
import jlogo7 from '../images/portfolio/7 logo.webp';
import jlogo8 from '../images/portfolio/8 logo.webp';
import jlogo9 from '../images/portfolio/9 logo.webp';
import jlogo10 from '../images/portfolio/10 logo.png';
import jlogo11 from '../images/portfolio/11 logo.webp';

const PortfolioSection = () => {
  return (
    <div>
          <section id="portfolio">
                <div className='container-xxl portfolio-container'>

                    <div className='text-box' data-aos="fade-up" data-aos-once="true">
                        <img id="recentworkimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                        <p>Recent Work</p>
                    </div>
                    <AnimatedText2 />

                    <div className='row journey-row'>
                        <div className='col-xs-12 main-col'>
                            <Marquee direction='left' className='marquee'>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey1' src={journey1} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ backgroundColor: "#212C1C", width: "42px", height: "37px" }}>
                                            <img alt='journey1' src={jlogo1} style={{ width: "30px", height: "22px" }} className='img-fluid' />
                                        </div>
                                        <p>Super Speciosa
                                        </p>
                                    </div>
                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey2' src={journey2} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ backgroundColor: "#383152", width: "42px", height: "37px" }}>
                                            <img alt='journey2' src={jlogo2} style={{ width: "30px", height: "24px" }} className='img-fluid' />
                                        </div>
                                        <p>Crescent days
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey3' src={journey3} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ width: "42px", height: "37px" }} >
                                            <img alt='journey3' src={jlogo3} style={{ width: "30px", height: "25px" }} className='img-fluid' />
                                        </div>
                                        <p>Miracle Noodle</p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey4' src={journey4} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ width: "58px", height: "37px" }} >
                                            <img alt='journey4' src={jlogo4} style={{ width: "50px", height: "20px" }} className='img-fluid' />
                                        </div>
                                        <p>Naturealm
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey5' src={journey5} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ width: "27px", height: "58px" }}>
                                            <img alt='journey5' src={jlogo5} style={{ width: "20px", height: "50px" }} className='img-fluid' />
                                        </div>
                                        <p style={{ marginTop: "15px" }}>Oot Granola
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey6' src={journey6} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ backgroundColor: "#EB5E17", width: "98px", height: "37px" }}>
                                            <img alt='journey6' src={jlogo6} style={{ width: "90px", height: "11px" }} className='img-fluid' />
                                        </div>
                                        <p>Super Feels
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey7' src={journey7} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ width: "58px", height: "37px" }}>
                                            <img alt='journey7' src={jlogo7} style={{ width: "50px", height: "10px" }} className='img-fluid' />
                                        </div>
                                        <p>Meroda
                                        </p>
                                    </div>
                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey8' src={journey8} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ width: "58px", height: "37px" }}>
                                            <img alt='journey8' src={jlogo8} style={{ width: "50px", height: "10px" }} className='img-fluid' />
                                        </div>
                                        <p>Manukora
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey9' src={journey9} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ backgroundColor: "#86DDDB", width: "60px", height: "37px" }}>
                                            <img alt='journey9' src={jlogo9} style={{ width: "50px", height: "18px" }} className='img-fluid' />
                                        </div>
                                        <p>Crispy Fantasy
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey10' src={journey10} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ backgroundColor: "#FFFFFFFF", width: "70px", height: "37px" }}>
                                            <img alt='journey10' src={jlogo10} style={{ width: "60px", height: "11px" }} className='img-fluid' />
                                        </div>
                                        <p>Nikura
                                        </p>
                                    </div>

                                </div>
                                <div className='box'>
                                    <div className='imgbox'>
                                        <img alt='journey11' src={journey11} className='img-fluid' />
                                    </div>
                                    <div className='content'>
                                        <div className='image' style={{ width: "60px", height: "37px" }}>
                                            <img alt='journey11' src={jlogo11} style={{ width: "50px", height: "16px" }} className='img-fluid' />
                                        </div>
                                        <p>Hay
                                        </p>
                                    </div>

                                </div>
                            </Marquee>
                        </div>
                        <div className='blurcol col1'></div>
                        <div className='blurcol col2'></div>
                    </div>
                </div>
            </section>
    </div>
  )
}

export default PortfolioSection